/** «город Нукус» → «Нукус», «Nukus shahri» / «Nókis qalası» → «Nukus» / «Nókis». Районы и области — без изменений. */
export function shortPlace(name: string): string {
  const short = name
    .replace(/^(город|г\.)\s+/i, '')
    .replace(/\s+(shahri|qalası|qalasi|shahar)$/i, '')
    .trim();
  return short || name;
}

/** Подпись места из нескольких частей («город Нукус, Каракалпакстан»): каждая часть — коротко. */
export function shortPlaces(label: string): string {
  return label.split(', ').map(shortPlace).join(', ');
}

/** «54000» → «54 000» (неразрывный пробел между разрядами). */
export function groupNumber(n: number): string {
  const [int, frac] = String(n).split('.');
  return int!.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + (frac ? `,${frac}` : '');
}
